import { useState, useContext } from "react";
import api from "./api/client";
import { AuthContext } from "./context/AuthContext";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pending) return;
    setError("");
    setPending(true);

    try {
      const resp = await api.post("/login", { username, password });
      login(resp.data.token);
    } catch (err) {
      console.error(err);
      setError("Login failed. Check username/password.");
    } finally {
      setPending(false);
    }
  };

  return (
    <main className="voice-login">
      <div className="voice-login-panel">
        <h1 className="voice-login-brand"><img src={`${process.env.PUBLIC_URL}/branding/motorava-lockup.svg`} alt="MotorAva — موتورآوا" className="voice-login-logo" width="940" height="940" /></h1>
        <p className="voice-login-intro">Sign in to record and identify engines.</p>

        <form onSubmit={handleSubmit}>
          <label className="voice-field">Username
          <input
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username" autoCapitalize="none" spellCheck="false" disabled={pending}
          />
          </label><label className="voice-field">Password

          <input
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password" disabled={pending}
          />
          </label>

          <button
            type="submit"
            className="voice-button" disabled={pending}
          >
            {pending ? "Signing in…" : "Login"}
          </button>
        </form>

        {error && (
          <p className="voice-inline-error" role="alert">{error}</p>
        )}
        <footer className="voice-footer">Iran Khodro Powertrain Company</footer>
      </div>
    </main>
  );
}
